import { css } from '@emotion/react';

import { Flex, Text, desktopFirstMediaQuery } from '@inflearn/ds-react-next';

export const SettingRow = ({
  label,
  labelRightSection,
  align = 'center',
  children,
  isEditMode = false,
  isRequired = false,
}: {
  label: string;
  labelRightSection?: React.ReactNode;
  align?: 'flex-start' | 'center';
  children: React.ReactNode;
  isEditMode?: boolean;
  isRequired?: boolean;
}) => (
  <Flex
    align={{ base: 'flex-start', md: align }}
    w="100%"
    gap={8}
    styles={{
      root: styleRow,
    }}
  >
    <Flex
      align="center"
      styles={{
        root: styleLabel,
      }}
      gap={8}
    >
      <Text
        component={isEditMode ? 'label' : 'div'}
        size="md"
        fw={500}
        py={8}
        c="gray.9"
        styles={{
          root: styleLabelText,
        }}
      >
        {label}
      </Text>
      {isRequired ? (
        <Text fz={14} c="red" fw={500}>
          *
        </Text>
      ) : (
        labelRightSection
      )}
    </Flex>
    <Flex
      styles={{
        root: styleContent,
      }}
    >
      {children}
    </Flex>
  </Flex>
);

const styleRow = css({
  [desktopFirstMediaQuery.mobile]: {
    flexDirection: 'column',
    gap: '4px',
  },
});

const styleLabel = css({
  flex: '0 0 140px',
  [desktopFirstMediaQuery.mobile]: {
    flex: '0 0 auto',
  },
});

const styleLabelText = css({
  flex: '0 0 auto',
  [desktopFirstMediaQuery.mobile]: {
    flex: '0 0 auto',
  },
});

const styleContent = css({
  flex: '1 1 auto',
  width: '100%',
  minWidth: 0,
});
